import Container from '@/components/atoms/Container'
import cohortsService from '@/services/cohortsService'
import { modalCreators } from '@/store/ducks/modal'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import utc from 'dayjs/plugin/utc.js'

dayjs.extend(utc)
dayjs.locale('pt-br')

export function Hero() {
	const {
		matriculate: { classSelect },
	} = useAppSelector((state) => state)
	const dispatch = useAppDispatch()

	const { data: progressCheckData } = cohortsService.getProgressChecks()

	const availableProgressChecks = progressCheckData?.progressChecks?.filter(
		(check) => check.isAvailable
	)

	const closestCheck = availableProgressChecks?.sort((a, b) => {
		return dayjs(a.data_inicio).diff(dayjs(b.data_inicio))
	})[0]

	useEffect(() => {
		if (
			progressCheckData?.progressChecks?.length &&
			progressCheckData?.show_modal_progress_check
		) {
			dispatch(
				modalCreators.openModal({
					name: 'progressCheckModal',
					disabledOnClose: true,
					modalInfo: closestCheck,
				})
			)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [progressCheckData?.show_modal_progress_check])

	return (
		<div className='flex w-full pt-10'>
			<Container>
				<div className='pb-4 md:pb-7'>
					<nav aria-label='breadcrumb' className='w-full'>
						<ol className='flex w-full flex-wrap items-center'>
							{classSelect?.name && (
								<li className='flex cursor-pointer items-center font-semibold text-sm text-white/60 transition-colors duration-300 hover:text-white'>
									<Link to='/curso'>Curso de {classSelect.name}</Link>

									{progressCheckData?.progressChecks &&
										progressCheckData?.progressChecks?.length > 0 && (
											<span className='pointer-events-none mx-2 mt-[2px] text-white'>
												/
											</span>
										)}
								</li>
							)}

							{progressCheckData?.progressChecks?.length && (
								<li className='flex cursor-pointer items-center font-semibold text-sm text-white transition-colors duration-300 hover:text-white'>
									<Link to='#'>Progress Check</Link>
								</li>
							)}
						</ol>
					</nav>
				</div>
			</Container>
		</div>
	)
}
